import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchGuide from './SearchGuide';
import PatternGuide from './PatternGuide';
import QuantGuide from './QuantGuide';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';

function Guide() {
  const [openMenu, setOpenMenu] = useState(false);

  const [tab, setTab] = useState('경공매 검색');

  const guideTab = sessionStorage.getItem('guideTab');

  useEffect(() => {
    if (guideTab && guideTab === 'search') {
      setTab('경공매 검색');
    }

    if (guideTab && guideTab === 'pattern') {
      setTab('알고리즘 분석');
    }

    if (guideTab && guideTab === 'quant') {
      setTab('퀀트 기반 테마 분석');
    }
    if (guideTab && guideTab === 'membership') {
      setTab('요금제 & 결제 방법');
    }
    if (guideTab && guideTab === 'etc') {
      setTab('기타');
    }
  }, [guideTab]);

  const tabItems = [
    {
      name: '경공매 검색',
      value: '경공매 검색',
      onclick: () => {
        sessionStorage.setItem('guideTab', 'search');
        setTab('경공매 검색');
      },
    },
    {
      name: '알고리즘 분석',
      value: '알고리즘 분석',
      onclick: () => {
        sessionStorage.setItem('guideTab', 'pattern');
        setTab('알고리즘 분석');
      },
    },
    {
      name: '퀀트 기반 테마 분석',
      value: '퀀트 기반 테마 분석',
      onclick: () => {
        sessionStorage.setItem('guideTab', 'quant');
        setTab('퀀트 기반 테마 분석');
      },
    },
    // {
    //   name: '멤버십 & 결제 방법',
    //   value: '멤버십 & 결제 방법',
    //   onclick: () => {
    //     sessionStorage.setItem('guideTab', 'membership');
    //     setTab('멤버십 & 결제 방법');
    //   },
    // },
    // {
    //   name: '기타',
    //   value: '기타',
    //   onclick: () => {
    //     sessionStorage.setItem('guideTab', 'etc');
    //     setTab('기타');
    //   },
    // },
  ];

  const renderContent = () => {
    if (tab === '경공매 검색') {
      return <SearchGuide />;
    }
    if (tab === '알고리즘 분석') {
      return <PatternGuide />;
    }
    if (tab === '퀀트 기반 테마 분석') {
      return <QuantGuide />;
    }
  };

  return (
    <PageContainer>
      <Container>
        <PageTop text="서비스 이용안내" />
        <Content>
          <TabBox>
            <TabInner>
              {tabItems.map((item, index) => (
                <Tab
                  active={tab === item.value}
                  onClick={item.onclick}
                  key={index}
                >
                  {item.name}
                </Tab>
              ))}
            </TabInner>
          </TabBox>
          <ContentBox>{renderContent()}</ContentBox>
        </Content>
        <Footer />
      </Container>
    </PageContainer>
  );
}

export default Guide;

const PageContainer = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const Container = styled.div`
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TabBox = styled.div`
  width: 100%;
  position: sticky;
  top: 56px;
  max-width: inherit;
  background-color: #fff;
  z-index: 1000;
  overflow-x: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

const TabInner = styled.div`
  padding: 0 16px 16px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  white-space: nowrap;

  &::after {
    content: '';
    flex: 0 0 10px;
  }
`;

const Tab = styled.div<{ active?: boolean }>`
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#ffffff' : '#989BA2')};
  background-color: ${(props) =>
    props.active ? '#222222' : 'rgba(112, 115, 124, 0.08)'};
  border-radius: 9999px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
`;

const ContentBox = styled.div`
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
`;
